"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockInformer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var StockBadge_1 = require("../Icons/StockBadge");
require("./style.scss");
var StockInformer = function (_a) {
    var isOutOfStock = _a.isOutOfStock, isRunningOut = _a.isRunningOut, stockLimit = _a.stockLimit;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isOutOfStock && (0, jsx_runtime_1.jsxs)("div", __assign({ className: 'product-stock-badge' }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: 'product-stock-badge-text' }, { children: t('Sold Out') })), (0, jsx_runtime_1.jsx)(StockBadge_1.StockBadge, {})] })), isRunningOut && (0, jsx_runtime_1.jsxs)("div", __assign({ className: 'product-stock-badge' }, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: 'product-stock-badge-text' }, { children: [stockLimit, " ", t('In Stock')] })), (0, jsx_runtime_1.jsx)(StockBadge_1.StockBadge, { color: '#F04438' })] }))] });
};
exports.StockInformer = StockInformer;
